export const environment = {
  HOST_URL: 'https://appservice-uat-ofw-backend-hefng6asdjcncdc6.southeastasia-01.azurewebsites.net',
  ADDRESS_API_URL: 'https://ap-uat-address-esfkf3g3bdcsdhcd.southeastasia-01.azurewebsites.net',
  PAYMENT_GATEWAY_URL: 'https://test.pesopay.com/b2cDemo/eng/payment/payForm.jsp',
};
